//@ts-check
import React, { Component } from 'react';
import { observer } from "mobx-react";
import { action } from 'mobx';
import IconsContainer from "Utils/IconsContainer";
import 'Styles/commonComponents/CheckboxWithText.scss';

/**
 * @typedef {object} props
 * @property {string} className
 * @property {boolean} checked
 * @property {(checked: boolean) => void} onChange
 * @property {import('react').CSSProperties | undefined} style
 * @property {string} [text]
 * @extends {Component<props>}
 */
class CheckboxWithText extends Component {
    render() {
        return (
            <div className={"CheckboxWithText " + (this.props.className ?? "")} style={this.props.style}>
                <div className="CheckboxWithText-icons"
                    onClick={action(_ => this.props.onChange(!this.props.checked))}>
                    <div className="CheckboxWithText-icon-off">
                        {IconsContainer.Get('ca-checkbox-off')}
                    </div>
                    <div className={"CheckboxWithText-icon-on " + (this.props.checked ? "checked" : "")}>
                        {IconsContainer.Get('ca-checkbox-on')}
                    </div>
                </div>
                <div className="CheckboxWithText-text">
                    {this.props.text}
                </div>
            </div>
        )
    }
};

export default observer(CheckboxWithText);